import { useSyncExternalStore } from "react";

type Query = `(width >= ${number}px)`;

export default function useMediaQuery(query: Query) {
    const subscribe = (callback: () => void) => {
        const mq = window.matchMedia(query);

        mq.addEventListener("change", callback);

        return () => mq.removeEventListener("change", callback);
    };

    const getSnapshot = () => window.matchMedia(query).matches;

    return useSyncExternalStore(subscribe, getSnapshot);
}
